module.exports = __webpack_public_path__ + "static/media/main idea.feaf0284.mp3";